import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthenticationService, TokensService } from '../services';
import { StorageService } from '../services/storage.service'
import { AlertService } from '../alert';

@Component({
    selector: 'login',
    providers: [TokensService, StorageService],
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    model: any = {};
    returnUrl: string;
    loading = false;
    clients: any[] = [];
    storages: any[] = [];
    token: any;
    storageName: string;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private tokensService: TokensService,
        private storageService: StorageService,
        private alertService: AlertService) { }

    ngOnInit() {
        this.authenticationService.logout();
        // reset login status
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    select(client: any) {
        this.loading = true;
        this.tokensService.changeClient(this.token, client.guid)
            .subscribe(
            data => {
                this.token = data;
                this.loading = false;
               // this.navigateBack();
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
            });
    }

    selectStorage(storage: any) {
        this.loading = true;
        this.storageName = storage.name;
        this.loading = false;
        this.navigateBack();
    }


    navigateBack() {
        this.authenticationService.setToken(this.token);
        this.authenticationService.setStorageName(this.storageName);
        // wenn default passwort dann routing auf passwort wechsel erzwingen
        if ((this.model.username + '123') == this.model.password) {
            this.router.navigate(['pwdChange']);
        } else {
            this.router.navigate([this.returnUrl]);
        }
    }

    checkClients() {
        this.loading = true;
        this.tokensService.getClients(this.token)
            .subscribe(
            data => {
                this.clients = data;
                this.loading = false;
                if (this.clients.length == 1) {
                //    this.navigateBack();
                }
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
            });
    }

    checkStorages() {
        this.loading = true;
        this.storageService.getStorages(this.token)
            .subscribe(
            data => {
                this.storages = data;
                this.loading = false;
                if (this.storages.length == 1) {
                //    this.navigateBack();
                }
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
            });
    }

    login() {
        this.loading = true;
        this.tokensService.login(this.model.username, this.model.password)
            .subscribe(
            data => {
                this.token = data;
                this.checkClients();
                this.checkStorages();
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
            });
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/login/login.component.ts